export const CLICK_EVENT = 'Click';
export const EXTEND_SONG_EVENT = 'Extend Song';
